import React, { HTMLAttributes } from 'react'
import styled, { css } from 'styled-components'

export const pStyles = css`
	font-size: 1rem;
	font-weight: 400;
	line-height: 1.333rem;
	margin: 0.5em 0;

	&.__bold {
		font-weight: 700;
		line-height: 1.5rem;
	}
	&.__big {
		font-size: 1.5rem;
		line-height: 2.4rem;
		margin: 1.2em 0;
	}
	&.__med {
		font-size: 1.3rem;
		line-height: 1.8rem;
		margin: 1em 0;
	}
	&.__center-text {
		text-align: center;
	}
	&.__err {
		color: ${props => props.theme.colors.err.val};
	}
	&.__primary {
		color: ${props => props.theme.colors.primary.val};
	}
	&.__secondary {
		color: ${props => props.theme.colors.secondary.val};
	}
	&.__itallic {
		font-style: italic;
	}
`

export const PView = styled.p`
	${pStyles}
`

type PProps = Pick<
	HTMLAttributes<HTMLParagraphElement>,
	'title' | 'className' | 'children' | 'aria-label' | 'id' | 'style'
> & {
	isBold?: boolean
	isBig?: boolean
	isMed?: boolean
	isErr?: boolean
	isPrimary?: boolean
	isSecondary?: boolean
	centerTxt?: boolean
	isItallic?: boolean
}
export const P = ({
	isBold,
	isBig,
	isMed,
	isErr,
	isPrimary,
	isSecondary,
	isItallic,
	centerTxt,
	className,
	children,
	...h5Attrs
}: PProps) => {
	return (
		<PView
			className={`${className ? ` ${className}` : ''}${isBold ? ` __bold` : ''}${
				isBig ? ' __big' : isMed ? ' __med' : ''
			}${centerTxt ? ' __center-text' : ''}${isItallic ? ' __itallic' : ''}${
				isPrimary ? ' __primary' : isSecondary ? ' __secondary' : isErr ? ' __err' : ''
			}`}
			{...h5Attrs}
		>
			{children}
		</PView>
	)
}
